import gql from 'graphql-tag';


export const GET_USER_SESSION = gql`
  {
    currentUser {
      user_id
      user_name
      email
      avatar
      roles
    }
  }
`;

export default {
  GET_USER_SESSION,
};
